<template>
  <div>
    <br />
    <h1 class="text-xs-center">Advanced: Other Settings</h1>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm10 md8 lg6 pa-2>
        <v-list two-line>
          <v-list-tile :to="{ name: 'advanced-payout-settings' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-money-check-edit-alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Payout Settings</v-list-tile-title>
              <v-list-tile-sub-title>Manage global payout fee settings by agency</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-beacon-settings' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-signal-stream</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Beacon Settings</v-list-tile-title>
              <v-list-tile-sub-title>Restrict assisted beacon registration by recent ticket purchase frequency</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider />
          <v-list-tile :to="{ name: 'advanced-revenue-exclusion-periods' }" ripple>
            <v-list-tile-action>
              <v-icon>fal fa-calendar-times</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Revenue Exclusion Periods</v-list-tile-title>
              <v-list-tile-sub-title>Manage dates excluded from transportation owner revenue and fees</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
